module.exports = __webpack_public_path__ + "21edcc0c0bf7800c6204e5566aca5421.png";